import { makeStyles } from '@fluentui/react-components';
import { useCallback, useState } from 'react';
import { Outlet } from 'react-router';

import { get as storageGet, set as storageSet } from '../common';
import { palette } from '../theme';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

const SIDEBAR_KEY = 'nuxni-time-tracker:sidebar-open';

const loadOpen = (): boolean => storageGet<boolean>(SIDEBAR_KEY) ?? true;

export const Layout: React.FC = () => {
    const classes = useStyles();
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => loadOpen());

    const toggleSidebar = useCallback(() => {
        setSidebarOpen((prev) => {
            const next = !prev;
            storageSet(SIDEBAR_KEY, next);
            return next;
        });
    }, []);

    return (
        <div className={classes.root}>
            <Sidebar open={sidebarOpen} onToggle={toggleSidebar} />
            <div className={classes.column}>
                <Header />
                <main className={classes.content}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100dvh',
        width: '100vw',
        overflow: 'hidden',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minWidth: 0,
        height: '100%',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
        backgroundColor: palette.pageBg,
        overflow: 'hidden',
    },
});
